import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { API_PREFIX } from './config/appConfig';
import './styles/global.css';
import AppRoutes from './routes/AppRoutes';

const useEnvironmentLogger = () => {
  useEffect(() => {
    console.log('%c [DEBUG] App.js - Environment Information - ', 'background: #222; color: #bada55; padding: 2px;', `ENV: ${process.env.NODE_ENV}, API: ${API_PREFIX}, TIME: ${new Date().toLocaleString()}`);
  }, []);
}

const App = () => {
  useEnvironmentLogger(); 

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <AppRoutes />
      </div>
    </Router>
  );
};

export default App;